// types
import { NavbarProps } from './types';

// components
import Left from '../icons/left';
import Right from '../icons/right';

export default function Navbar({
  onPreviousClick,
  onNextClick,
  className,
}: NavbarProps): React.JSX.Element {
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => onPreviousClick && onPreviousClick()}
        aria-label="Left arrow"
      >
        <Left />
      </button>
      <button
        type="button"
        onClick={() => onNextClick && onNextClick()}
        aria-label="Right arrow"
      >
        <Right />
      </button>
    </div>
  );
}
